import _get from 'lodash/get';
import { Values } from '@lib/interfaces/form';
import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';
import { MonitoringEntity } from '../enums';

export default function getMonitoringEntity({ filterParams }: Values) {
  return _get(
    filterParams,
    MonitoringFilterFieldNames.Entity,
    MonitoringEntity.Site,
  ) as MonitoringEntity;
}
